import { Col, Input } from "antd";
import FormInputDivider from "./FormInputDivider";
import { StyledForm } from "../styles";
import mask from "utils/masks";

function PortalInputText({input, divider, colSpan, ...props}){
    const handlePhoneOnchange = (e)=>{
        var maskedValue = mask(e.target.value, "phone");
        if(maskedValue != e.target.value){
            props.form.setFieldValue(input.name, maskedValue)
        }
    }
    return(
        <FormInputDivider key={input.name} {...divider} >
            <Col span={colSpan ? colSpan : (props.inputColSpan? props.inputColSpan : 24)} key={input.name}>
                <Col span={input?.colSpan ? input.colSpan : 24} style={{padding:"0px"}}>
                        <StyledForm.Item {...input} extra={props.helpMessage} hidden={input.hidden}>
                            {
                                input.type == "text" ?
                                    <Input disabled={input?.disabled} addonBefore={input?.addonBefore} addonAfter={input?.addonAfter} />    
                                :
                                input.type == "textarea" ?
                                    <Input.TextArea disabled={input?.disabled} rows={input.rows || 4} />
                                :
                                input.type == "phone" ?
                                    <Input disabled={input?.disabled} addonBefore={input?.addonBefore} addonAfter={input?.addonAfter} onChange={handlePhoneOnchange}/>
                                : 
                                    null
                            }
                        </StyledForm.Item>
                </Col>
            </Col>
        </FormInputDivider>
        
    )
}

export default PortalInputText;
